// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "drills" + "." + "073a236a" + ".chunk.js";
};